var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-back"},[_c('button',{staticClass:"button is-white is-large is-pulled-right"},[_c('span',{staticClass:"mr-5 is-size-6 is-inline-block"},[_vm._v(" "+_vm._s(_vm.$t("simulator.askForHelp"))+" ")]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon is-large ml-2 is-size-6"},[_c('span',{staticClass:"fas fa-hands-helping"})])
}]

export { render, staticRenderFns }